import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-end;
`;
